/**
 * Product Bespoke Options Component
 */

(function() {
'use strict';

/**
 * Icon Registry (inlined to avoid ES module caching issues)
 */
const icons = {
  /**
   * Plus icon (commonly used for increment actions)
   * @returns {string} SVG markup
   */
  plus() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12.9 4.5c0-.499-.401-.9-.9-.9s-.9.401-.9.9v6.6H4.5c-.499 0-.9.401-.9.9s.401.9.9.9h6.6v6.6c0 .499.401.9.9.9s.9-.401.9-.9v-6.6h6.6c.499 0 .9-.401.9-.9s-.401-.9-.9-.9h-6.6V4.5Z" />
    </svg>`;
  },

  /**
   * Minus icon (commonly used for decrement actions)
   * @returns {string} SVG markup
   */
  minus() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M3.6 12c0-.499.4-.9.9-.9h15c.498 0 .9.401.9.9s-.402.9-.9.9h-15c-.5 0-.9-.401-.9-.9Z" />
    </svg>`;
  },

  /**
   * Chevron down icon (commonly used for accordions and dropdowns)
   * @returns {string} SVG markup
   */
  chevronDown() {
    return `<svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
    </svg>`;
  },

  /**
   * Arrow right icon (commonly used for navigation)
   * @returns {string} SVG markup
   */
  arrowRight() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M9 6l6 6l-6 6" />
    </svg>`;
  },

  /**
   * Info circle icon (used for tooltip triggers in bespoke options)
   * @returns {string} SVG markup
   */
  infoCircle() {
    return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0004 4.20002C16.3091 4.20002 19.8004 7.69127 19.8004 12C19.8004 16.3088 16.3091 19.8 12.0004 19.8C7.69164 19.8 4.20039 16.3088 4.20039 12C4.20039 7.69127 7.69164 4.20002 12.0004 4.20002ZM12.0004 21.6C17.3029 21.6 21.6004 17.3025 21.6004 12C21.6004 6.69753 17.3029 2.40002 12.0004 2.40002C6.69789 2.40002 2.40039 6.69753 2.40039 12C2.40039 17.3025 6.69789 21.6 12.0004 21.6ZM10.5004 15C10.0016 15 9.60039 15.4013 9.60039 15.9C9.60039 16.3988 10.0016 16.8 10.5004 16.8H13.5004C13.9991 16.8 14.4004 16.3988 14.4004 15.9C14.4004 15.4013 13.9991 15 13.5004 15H13.2004V11.7C13.2004 11.2013 12.7991 10.8 12.3004 10.8H10.5004C10.0016 10.8 9.60039 11.2013 9.60039 11.7C9.60039 12.1988 10.0016 12.6 10.5004 12.6H11.4004V15H10.5004ZM12.0004 9.60002C12.6641 9.60002 13.2004 9.06377 13.2004 8.40002C13.2004 7.73627 12.6641 7.20002 12.0004 7.20002C11.3366 7.20002 10.8004 7.73627 10.8004 8.40002C10.8004 9.06377 11.3366 9.60002 12.0004 9.60002Z" fill="currentColor"/>
    </svg>`;
  },

  /**
   * Checkmark icon (used for custom checkboxes)
   * @returns {string} SVG markup
   */
  check() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
      <path d="M5 12l5 5L19 7" />
    </svg>`;
  },

  /**
   * Check circle icon (filled circle with white checkmark, used for completion indicators)
   * @returns {string} SVG markup
   */
  checkCircle() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12C24 18.6281 18.6281 24 12 24ZM17.5312 6.82969C17.0297 6.46406 16.3266 6.57656 15.9609 7.07812L10.3641 14.775L7.92188 12.3328C7.48125 11.8922 6.76875 11.8922 6.33281 12.3328C5.89688 12.7734 5.89219 13.4859 6.33281 13.9219L9.70781 17.2969C9.94219 17.5312 10.2609 17.6484 10.5891 17.625C10.9172 17.6016 11.2172 17.4328 11.4094 17.1656L17.7797 8.4C18.1453 7.89844 18.0328 7.19531 17.5312 6.82969Z" />
    </svg>`;
  },

  /**
   * Close icon (cross/dismiss, used for close buttons)
   * @returns {string} SVG markup
   */
  close() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor">
      <path d="M6.77499 8.45C6.30499 7.98 6.30499 7.22 6.77499 6.755C7.24499 6.29 8.00498 6.285 8.46999 6.755L16.02 14.305L23.57 6.755C24.04 6.285 24.8 6.285 25.265 6.755C25.73 7.225 25.735 7.985 25.265 8.45L17.715 16L25.265 23.55C25.735 24.02 25.735 24.78 25.265 25.245C24.795 25.71 24.035 25.715 23.57 25.245L16.02 17.695L8.46999 25.245C7.99999 25.715 7.23999 25.715 6.77499 25.245C6.30999 24.775 6.30499 24.015 6.77499 23.55L14.325 16L6.77499 8.45Z" />
    </svg>`;
  },

  /**
   * Basket with plus icon (used for add to cart in product addons)
   * @returns {string} SVG markup
   */
  basketPlus() {
    return `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2.40002C12.2475 2.40002 12.4837 2.50127 12.6525 2.68127L18.0525 8.38127L18.0712 8.40002H21C21.6637 8.40002 22.2 8.93627 22.2 9.60002C22.2 10.1438 21.84 10.6013 21.345 10.7513L19.6162 18.5213C19.3725 19.62 18.3975 20.4 17.2725 20.4H6.72374C5.59874 20.4 4.62374 19.62 4.37999 18.5213L2.65499 10.7513C2.15999 10.605 1.79999 10.1438 1.79999 9.60002C1.79999 8.93627 2.33624 8.40002 2.99999 8.40002H5.92874L5.94749 8.38127L11.3475 2.68127C11.5162 2.50127 11.7525 2.40002 12 2.40002ZM12 4.60877L8.40749 8.40002H15.5925L12 4.60877ZM12 10.8C11.5012 10.8 11.1 11.2013 11.1 11.7V13.5H9.29999C8.80124 13.5 8.39999 13.9013 8.39999 14.4C8.39999 14.8988 8.80124 15.3 9.29999 15.3H11.1V17.1C11.1 17.5988 11.5012 18 12 18C12.4987 18 12.9 17.5988 12.9 17.1V15.3H14.7C15.1987 15.3 15.6 14.8988 15.6 14.4C15.6 13.9013 15.1987 13.5 14.7 13.5H12.9V11.7C12.9 11.2013 12.4987 10.8 12 10.8Z" fill="white"/>
    </svg>`;
  }
};

/**
 * Bespoke Utilities (inlined to avoid ES module caching issues)
 */
const UNIT_RATIO = 25.4;
const UNIT_STORAGE_KEY = 'dd-unit-preference';

/**
 * Checks if the current unit preference is imperial (inches)
 * @returns {boolean} True if imperial, false if metric
 */
function isImperial() {
  if (typeof window.isImperialUnit === 'function') {
    return window.isImperialUnit();
  }
  return localStorage.getItem(UNIT_STORAGE_KEY) === 'inches';
}

/**
 * Converts millimeters to inches, formatted to 2 decimal places
 * @param {number} mm - Value in millimeters
 * @returns {string} Formatted value in inches
 */
function toInches(mm) {
  return (mm / UNIT_RATIO).toFixed(2);
}

/**
 * Converts inches to millimeters, rounded to whole number
 * @param {number} inches - Value in inches
 * @returns {number} Value in millimeters (integer)
 */
function toMm(inches) {
  return Math.round(inches * UNIT_RATIO);
}

/**
 * Formats a dimension value with the appropriate unit symbol
 * @param {number} mmValue - Value in millimeters (always stored in mm)
 * @param {boolean} [useImperial] - Override unit preference (defaults to current preference)
 * @returns {string} Formatted value with unit (e.g., "600mm" or "23.62"")
 */
function formatDimension(mmValue, useImperial) {
  const imperial = useImperial !== undefined ? useImperial : isImperial();
  if (imperial) {
    return toInches(mmValue) + '"';
  }
  return mmValue + 'mm';
}

/**
 * Formats a dimension range with the appropriate unit
 * @param {number} minMm - Minimum value in millimeters
 * @param {number} maxMm - Maximum value in millimeters
 * @param {boolean} [useImperial] - Override unit preference (defaults to current preference)
 * @returns {string} Formatted range (e.g., "600 - 1050 mm" or "23.62-41.34"")
 */
function formatDimensionRange(minMm, maxMm, useImperial) {
  const imperial = useImperial !== undefined ? useImperial : isImperial();
  if (imperial) {
    return `${toInches(minMm)}-${toInches(maxMm)}"`;
  }
  return `${minMm} - ${maxMm} mm`;
}

/**
 * Validates a dimension input against its min/max constraints
 * @param {HTMLInputElement} input - The input element with min/max attributes
 * @returns {Object} Validation result object
 */
function getDimensionValidation(input) {
  const value = parseFloat(input.value);
  const min = parseFloat(input.min);
  const max = parseFloat(input.max);
  const hasValue = input.value !== '' && !isNaN(value);

  const isBelowMin = hasValue && value < min;
  const isAboveMax = hasValue && value > max;

  return {
    value,
    hasValue,
    isBelowMin,
    isAboveMax,
    isOutOfRange: isBelowMin || isAboveMax,
    isValid: !hasValue || (!isBelowMin && !isAboveMax),
  };
}

/**
 * Generates an error message for dimension validation
 * @param {Object} validation - Result from getDimensionValidation
 * @param {number} minMm - Original minimum in millimeters
 * @param {number} maxMm - Original maximum in millimeters
 * @param {Object} translations - Translation strings
 * @returns {string|null} Error message or null if valid
 */
function getDimensionErrorMessage(validation, minMm, maxMm, translations) {
  if (!validation.isOutOfRange) {
    return null;
  }

  if (validation.isBelowMin) {
    return `${translations.minError} ${formatDimension(minMm)}`;
  }

  if (validation.isAboveMax) {
    return `${translations.maxError} ${formatDimension(maxMm)}`;
  }

  return null;
}

/**
 * Parses dimension data attributes from an element
 * @param {HTMLElement} element - Element with data-min-mm and data-max-mm attributes
 * @returns {Object} Parsed values with minMm, maxMm, and valid properties
 */
function parseDimensionData(element) {
  const minMm = parseFloat(element.dataset.minMm);
  const maxMm = parseFloat(element.dataset.maxMm);

  return {
    minMm,
    maxMm,
    valid: !isNaN(minMm) && !isNaN(maxMm),
  };
}

/**
 * Updates an input element's min/max attributes for unit conversion
 * @param {HTMLInputElement} input - The input element
 * @param {number} minMm - Original minimum in millimeters
 * @param {number} maxMm - Original maximum in millimeters
 * @param {boolean} toImperialUnit - Whether to convert to imperial
 */
function updateInputMinMax(input, minMm, maxMm, toImperialUnit) {
  if (toImperialUnit) {
    input.min = toInches(minMm);
    input.max = toInches(maxMm);
  } else {
    input.min = minMm;
    input.max = maxMm;
  }
}

/**
 * Converts an input value between units
 * @param {HTMLInputElement} input - The input element
 * @param {boolean} toImperialUnit - Whether to convert to imperial
 */
function convertInputValue(input, toImperialUnit) {
  const currentValue = parseFloat(input.value);

  if (isNaN(currentValue) || currentValue <= 0) {
    return;
  }

  if (toImperialUnit) {
    input.value = toInches(currentValue);
  } else {
    input.value = toMm(currentValue);
  }
}

/**
 * Bespoke Custom Select (inlined to avoid ES module caching issues)
 */
const bespokeDesktopQuery = window.matchMedia('(min-width: 750px)');
const MEASUREMENT_PATTERN = /((?:\d+(?:x)\d+(?:x)\d+mm)|(?:(?:\d+(?:x|-)|)\d+mm))(?=[^-"]|$)/gi;

/**
 * Converts a measurement string from mm to inches
 * @param {string} metricStr - String like "40mm" or "100x200mm"
 * @returns {string} Imperial string like "1.57"" or "3.94x7.87""
 */
function convertToImperial(metricStr) {
  const cleanValue = metricStr.replace('mm', '');

  if (cleanValue.includes('x')) {
    const parts = cleanValue.split('x');
    const converted = parts.map(part => toInches(parseFloat(part)));
    return converted.join('x') + '"';
  }

  if (cleanValue.includes('-')) {
    const parts = cleanValue.split('-');
    const converted = parts.map(part => toInches(parseFloat(part)));
    return converted.join('-') + '"';
  }

  return toInches(parseFloat(cleanValue)) + '"';
}

/**
 * Converts measurement labels based on current unit preference
 * @param {string} label - Original label text
 * @returns {string} Converted label
 */
function convertLabel(label) {
  if (!isImperial()) return label;
  return label.replace(MEASUREMENT_PATTERN, (match) => convertToImperial(match));
}

/**
 * Creates a bespoke dropdown field with optional custom select for desktop.
 * @param {Object} dropdown - Dropdown config object
 * @param {Object} options - Configuration options
 * @returns {Object} Object with container, select, and refresh function
 */
function createBespokeDropdown(dropdown, options) {
  const {
    formatMoney,
    renderTooltip,
    placeholderText = 'Please choose...'
  } = options;

  const container = document.createElement('div');
  container.className = 'product-bespoke-dropdown';
  container.dataset.dropdownId = dropdown.id;

  const labelRow = document.createElement('div');
  labelRow.className = 'product-bespoke-dropdown__label-row';

  const label = document.createElement('span');
  label.className = 'product-bespoke-dropdown__label';
  label.textContent = dropdown.label;
  labelRow.appendChild(label);

  if (dropdown.helpText && renderTooltip) {
    labelRow.appendChild(renderTooltip(dropdown.helpText));
  }

  container.appendChild(labelRow);

  const select = buildBespokeNativeSelect(dropdown, formatMoney, placeholderText);
  container.appendChild(select);

  let refresh = () => {};

  if (bespokeDesktopQuery.matches) {
    const customSelect = buildBespokeCustomSelect(dropdown, select, formatMoney, placeholderText);
    container.appendChild(customSelect);
    select.classList.add('bespoke-custom-select-active');
    select.setAttribute('tabindex', '-1');

    refresh = () => syncBespokeCustomFromNative(select, customSelect, dropdown);
  }

  return { container, select, refresh };
}

/**
 * Builds the native select element
 */
function buildBespokeNativeSelect(dropdown, formatMoney, placeholderText) {
  const select = document.createElement('select');
  select.className = 'product-bespoke-dropdown__select';
  select.dataset.dropdownId = dropdown.id;
  select.dataset.label = dropdown.label;
  select.setAttribute('aria-label', dropdown.label);

  const placeholder = document.createElement('option');
  placeholder.value = '';
  placeholder.textContent = placeholderText;
  placeholder.disabled = true;
  placeholder.selected = true;
  select.appendChild(placeholder);

  dropdown.values.forEach(value => {
    const option = document.createElement('option');
    option.value = value.id;
    option.dataset.label = value.label;
    option.dataset.labelOriginal = value.label;
    option.dataset.priceAdjustment = value.priceAdjustment || 0;
    if (value.swatch) {
      option.dataset.swatch = value.swatch;
    }

    const displayLabel = convertLabel(value.label);
    let text = displayLabel;
    if (value.priceAdjustment > 0) {
      text += ` (+${formatMoney(value.priceAdjustment)})`;
    }
    option.textContent = text;
    select.appendChild(option);
  });

  return select;
}

/**
 * Builds the custom ARIA combobox overlay for desktop
 */
function buildBespokeCustomSelect(dropdown, select, formatMoney, placeholderText) {
  const wrapper = document.createElement('div');
  wrapper.className = 'bespoke-custom-select';

  const listboxId = `bespoke-listbox-${dropdown.id}-${Date.now()}`;

  const trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'bespoke-custom-select__trigger';
  trigger.setAttribute('role', 'combobox');
  trigger.setAttribute('aria-expanded', 'false');
  trigger.setAttribute('aria-haspopup', 'listbox');
  trigger.setAttribute('aria-controls', listboxId);
  trigger.setAttribute('aria-label', dropdown.label);

  const triggerContent = document.createElement('span');
  triggerContent.className = 'bespoke-custom-select__trigger-content';

  const valueSpan = document.createElement('span');
  valueSpan.className = 'bespoke-custom-select__value';
  valueSpan.textContent = placeholderText;

  triggerContent.appendChild(valueSpan);

  const iconSpan = document.createElement('span');
  iconSpan.className = 'bespoke-custom-select__icon';
  iconSpan.innerHTML = icons.chevronDown();

  trigger.appendChild(triggerContent);
  trigger.appendChild(iconSpan);

  const listbox = document.createElement('ul');
  listbox.className = 'bespoke-custom-select__listbox';
  listbox.id = listboxId;
  listbox.setAttribute('role', 'listbox');
  listbox.setAttribute('tabindex', '-1');

  dropdown.values.forEach(value => {
    const li = document.createElement('li');
    li.className = 'bespoke-custom-select__option';
    li.setAttribute('role', 'option');
    li.setAttribute('aria-selected', 'false');
    li.dataset.value = value.id;
    li.dataset.labelOriginal = value.label;
    li.dataset.priceAdjustment = value.priceAdjustment || 0;

    if (value.swatch) {
      const img = document.createElement('img');
      img.className = 'bespoke-custom-select__swatch';
      img.src = value.swatch;
      img.alt = '';
      img.width = 24;
      img.height = 24;
      img.loading = 'lazy';
      li.appendChild(img);
    }

    const optionLabel = document.createElement('span');
    optionLabel.className = 'bespoke-custom-select__option-label';

    const displayLabel = convertLabel(value.label);
    optionLabel.textContent = displayLabel;
    li.appendChild(optionLabel);

    if (value.priceAdjustment > 0) {
      const optionPrice = document.createElement('span');
      optionPrice.className = 'bespoke-custom-select__option-price';
      optionPrice.textContent = `(+${formatMoney(value.priceAdjustment)})`;
      li.appendChild(optionPrice);
}

    listbox.appendChild(li);
  });

  wrapper.appendChild(trigger);
  wrapper.appendChild(listbox);

  attachBespokeBehaviors(wrapper, trigger, listbox, select, dropdown, placeholderText);

  return wrapper;
}

/**
 * Attaches open/close, selection, keyboard, and outside-click behaviors
 */
function attachBespokeBehaviors(wrapper, trigger, listbox, select, dropdown, placeholderText) {
  let focusedIndex = -1;

  function open() {
    wrapper.classList.add('bespoke-custom-select--open');
    trigger.setAttribute('aria-expanded', 'true');

    const selectedOption = listbox.querySelector('[aria-selected="true"]');
    if (selectedOption) {
      focusedIndex = Array.from(listbox.children).indexOf(selectedOption);
      selectedOption.classList.add('bespoke-custom-select__option--focused');
    } else {
      focusedIndex = -1;
    }

    listbox.focus();
  }

  function close() {
    wrapper.classList.remove('bespoke-custom-select--open');
    trigger.setAttribute('aria-expanded', 'false');
    clearFocus();
    trigger.focus();
  }

  function clearFocus() {
    listbox.querySelectorAll('.bespoke-custom-select__option--focused').forEach(el => {
      el.classList.remove('bespoke-custom-select__option--focused');
    });
  }

  function focusOption(index) {
    const items = listbox.children;
    if (index < 0 || index >= items.length) return;

    clearFocus();
    focusedIndex = index;
    items[focusedIndex].classList.add('bespoke-custom-select__option--focused');
    items[focusedIndex].scrollIntoView({ block: 'nearest' });
  }

  function selectValue(valueId) {
    select.value = valueId;
    select.classList.add('has-value');
    select.dispatchEvent(new Event('change', { bubbles: true }));

    syncBespokeCustomFromNative(select, wrapper, dropdown);
    close();
  }

  function isOpen() {
    return wrapper.classList.contains('bespoke-custom-select--open');
  }

  trigger.addEventListener('click', (e) => {
    e.preventDefault();
    if (isOpen()) {
      close();
    } else {
      open();
    }
  });

  listbox.addEventListener('click', (e) => {
    const option = e.target.closest('.bespoke-custom-select__option');
    if (!option) return;
    selectValue(option.dataset.value);
  });

  listbox.addEventListener('keydown', (e) => {
    const items = listbox.children;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusOption(Math.min(focusedIndex + 1, items.length - 1));
        break;
      case 'ArrowUp':
        e.preventDefault();
        focusOption(Math.max(focusedIndex - 1, 0));
        break;
      case 'Enter':
      case ' ':
        e.preventDefault();
        if (focusedIndex >= 0 && focusedIndex < items.length) {
          selectValue(items[focusedIndex].dataset.value);
        }
        break;
      case 'Escape':
        e.preventDefault();
        close();
        break;
      case 'Tab':
        close();
        break;
    }
  });

  trigger.addEventListener('keydown', (e) => {
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !isOpen()) {
      e.preventDefault();
      open();
    }
  });

  document.addEventListener('click', (e) => {
    if (isOpen() && !wrapper.contains(e.target)) {
      close();
    }
  });
}

/**
 * Syncs the custom dropdown visual state from the native select's current value
 */
function syncBespokeCustomFromNative(select, customWrapper, dropdown) {
  const triggerContent = customWrapper.querySelector('.bespoke-custom-select__trigger-content');
  const valueSpan = triggerContent?.querySelector('.bespoke-custom-select__value');
  const options = customWrapper.querySelectorAll('.bespoke-custom-select__option');

  if (!valueSpan) return;

  const existingSwatch = triggerContent.querySelector('.bespoke-custom-select__trigger-swatch');
  if (existingSwatch) existingSwatch.remove();

  options.forEach(opt => opt.setAttribute('aria-selected', 'false'));

  if (!select.value) {
    valueSpan.textContent = select.options[0]?.textContent || 'Please choose...';
    triggerContent.classList.remove('bespoke-custom-select__trigger-content--has-value');
    return;
  }

  const selectedNativeOption = select.options[select.selectedIndex];
  const selectedCustomOption = customWrapper.querySelector(
    `.bespoke-custom-select__option[data-value="${select.value}"]`
  );

  if (selectedCustomOption) {
    selectedCustomOption.setAttribute('aria-selected', 'true');
  }

  valueSpan.textContent = selectedNativeOption?.textContent || select.value;
  triggerContent.classList.add('bespoke-custom-select__trigger-content--has-value');

  const matchedValue = dropdown.values.find(v => v.id === select.value);
  if (matchedValue?.swatch) {
    const swatchImg = document.createElement('img');
    swatchImg.className = 'bespoke-custom-select__trigger-swatch';
    swatchImg.src = matchedValue.swatch;
    swatchImg.alt = '';
    swatchImg.width = 24;
    swatchImg.height = 24;
    triggerContent.insertBefore(swatchImg, valueSpan);
  }
}

/**
 * Refreshes all custom dropdowns within a given root element.
 * @param {HTMLElement} root - Parent element containing bespoke dropdowns
 * @param {Array} [dropdownConfigs] - Array of dropdown config objects for swatch data
 */
function refreshCustomDropdowns(root, dropdownConfigs) {
  if (!root) return;

  const customSelects = root.querySelectorAll('.bespoke-custom-select');
  customSelects.forEach(customWrapper => {
    const container = customWrapper.closest('.product-bespoke-dropdown');
    if (!container) return;

    const select = container.querySelector('.product-bespoke-dropdown__select');
    if (!select) return;

    const dropdownId = select.dataset.dropdownId;
    const dropdown = dropdownConfigs?.find(d => d.id === dropdownId) || { values: [] };

    syncBespokeCustomFromNative(select, customWrapper, dropdown);
  });
}

/**
 * Updates dropdown labels when unit preference changes.
 * @param {HTMLElement} root - Parent element containing bespoke dropdowns
 * @param {Function} formatMoney - Money formatter function
 */
function updateDropdownUnits(root, formatMoney) {
  if (!root) return;

  const nativeSelects = root.querySelectorAll('.product-bespoke-dropdown__select');
  nativeSelects.forEach(select => {
    Array.from(select.options).forEach(option => {
      if (!option.dataset.labelOriginal) return;

      const displayLabel = convertLabel(option.dataset.labelOriginal);
      const priceAdjustment = parseInt(option.dataset.priceAdjustment) || 0;

      let text = displayLabel;
      if (priceAdjustment > 0 && formatMoney) {
        text += ` (+${formatMoney(priceAdjustment)})`;
      }
      option.textContent = text;
    });
  });

  const customOptions = root.querySelectorAll('.bespoke-custom-select__option');
  customOptions.forEach(option => {
    if (!option.dataset.labelOriginal) return;

    const labelSpan = option.querySelector('.bespoke-custom-select__option-label');
    if (!labelSpan) return;

    const displayLabel = convertLabel(option.dataset.labelOriginal);
    const priceAdjustment = parseInt(option.dataset.priceAdjustment) || 0;

    let text = displayLabel;
    if (priceAdjustment > 0 && formatMoney) {
      text += ` (+${formatMoney(priceAdjustment)})`;
    }
    labelSpan.textContent = text;
  });

  const triggerValues = root.querySelectorAll('.bespoke-custom-select__value');
  triggerValues.forEach(valueSpan => {
    const customWrapper = valueSpan.closest('.bespoke-custom-select');
    const container = customWrapper?.closest('.product-bespoke-dropdown');
    const select = container?.querySelector('.product-bespoke-dropdown__select');

    if (select && select.value) {
      const selectedOption = select.options[select.selectedIndex];
      if (selectedOption) {
        valueSpan.textContent = selectedOption.textContent;
      }
    }
  });
}

/**
 * Product Bespoke Options Web Component
 * Renders and manages bespoke option fields (dropdowns, dimensions, confirmation)
 * for the main product form on PDP.
 *
 * Reads config from a <script type="application/json" data-bespoke-config> block
 * inside the custom element. Both metaobject and legacy data paths produce
 * identical JSON — this component handles one normalized shape.
 *
 * Dispatches 'bespoke:change' events for integration with product-variants.js
 */
class ProductBespokeOptions extends HTMLElement {
  constructor() {
    super();

    /** @type {Object|null} */
    this.config = null;

    /** @type {boolean} */
    this.isValid = false;

    /** @type {number} */
    this.priceAdjustment = 0;

    /** @type {boolean} Whether the user has interacted with the form */
    this.showErrors = false;

    /** @type {Set<HTMLInputElement>} Dimension inputs that have been blurred */
    this.touchedDimensions = new Set();
  }

  connectedCallback() {
    const configScript = this.querySelector('[data-bespoke-config]');
    if (!configScript) return;

    try {
      this.config = JSON.parse(configScript.textContent);
    } catch {
      return;
    }

    this.formContainer = this.querySelector('[data-bespoke-form]');
    this.validationMessage = this.querySelector('[data-bespoke-validation]');
    if (!this.formContainer) return;

    this.renderForm();
    this.setupOutsideClickHandler();
    this.setupUnitChangeListener();
    this.validate();
  }

  /**
   * Sets up listener for unit toggle changes to update dimension fields
   */
  setupUnitChangeListener() {
    document.addEventListener('unit:changed', (event) => {
      this.updateDimensionUnits(event.detail.isImperial);
      updateDropdownUnits(this.formContainer, (cents) => this.formatMoney(cents));
    });

    if (isImperial()) {
      this.updateDimensionUnits(true);
      updateDropdownUnits(this.formContainer, (cents) => this.formatMoney(cents));
    }
  }

  /**
   * Updates all dimension field units based on selected unit
   * @param {boolean} isImperial - Whether to show imperial (inches) or metric (mm)
   */
  updateDimensionUnits(isImperial) {
    this.updateUnitLabels(isImperial);
    this.updateRangeHints(isImperial);
    this.querySelectorAll('.product-bespoke-dimension__input').forEach(input => {
      this.updateDimensionInput(input, isImperial);
    });
  }

  /**
   * Updates unit label text (mm or ")
   * @param {boolean} isImperial - Whether to show imperial
   */
  updateUnitLabels(isImperial) {
    this.querySelectorAll('.product-bespoke-dimension__unit').forEach(label => {
      label.textContent = isImperial ? '"' : 'mm';
    });
  }

  /**
   * Updates range hint text with converted values
   * @param {boolean} toImperial - Whether to show imperial
   */
  updateRangeHints(toImperial) {
    this.querySelectorAll('.product-bespoke-dimension__range-hint').forEach(hint => {
      const data = parseDimensionData(hint);
      if (!data.valid) return;

      hint.textContent = formatDimensionRange(data.minMm, data.maxMm, toImperial);
    });
  }

  /**
   * Updates a single dimension input's min/max, value, and error message
   * @param {HTMLInputElement} input - The dimension input element
   * @param {boolean} toImperial - Whether to show imperial
   */
  updateDimensionInput(input, toImperial) {
    const data = parseDimensionData(input);
    if (!data.valid) return;

    updateInputMinMax(input, data.minMm, data.maxMm, toImperial);
    convertInputValue(input, toImperial);
    this.updateDimensionErrorMessage(input, data.minMm, data.maxMm);
  }

  /**
   * Updates visible error message to reflect current unit
   * @param {HTMLInputElement} input - The dimension input element
   * @param {number} minMm - Minimum value in mm
   * @param {number} maxMm - Maximum value in mm
   */
  updateDimensionErrorMessage(input, minMm, maxMm) {
    const field = input.closest('.product-bespoke-dimension__field');
    const errorMsg = field?.querySelector('.product-bespoke-dimension__error');
    if (!errorMsg || errorMsg.hidden) return;

    const validation = getDimensionValidation(input);
    const translations = {
      minError: this.getTranslation('dimensionMinError', 'Min is'),
      maxError: this.getTranslation('dimensionMaxError', 'Max is'),
    };
    const message = getDimensionErrorMessage(validation, minMm, maxMm, translations);

    if (message) {
      errorMsg.textContent = message;
    }
  }

  /**
   * Renders all bespoke option fields into the form container
   */
  renderForm() {
    const fragment = document.createDocumentFragment();

    if (this.config.dimensions && this.config.dimensions.length > 0) {
      this.config.dimensions.forEach(dimension => {
        fragment.appendChild(this.renderDimension(dimension));
      });
    }

    if (this.config.dropdown && this.config.dropdown.length > 0) {
      this.config.dropdown.forEach(dropdown => {
        fragment.appendChild(this.renderDropdown(dropdown));
      });
    }

    if (this.config.confirmation) {
      fragment.appendChild(this.renderConfirmation(this.config.confirmation));
    }

    this.formContainer.appendChild(fragment);
  }

  /**
   * Renders a dropdown field group
   * @param {Object} dropdown - Dropdown config object
   * @returns {HTMLElement} Dropdown field container
   */
  renderDropdown(dropdown) {
  const result = createBespokeDropdown(dropdown, {
    formatMoney: (cents) => this.formatMoney(cents),
    renderTooltip: (helpText) => this.renderTooltip(helpText),
    placeholderText: this.getTranslation('select_placeholder', 'Please choose...')
  });

  const followUpContainer = document.createElement('div');
  followUpContainer.className = 'product-bespoke-dropdown__follow-up';
  result.container.appendChild(followUpContainer);

  const updateFollowUp = () => {
    followUpContainer.replaceChildren();

    const selectedValue = dropdown.values.find(
      value => value.id === result.select.value
    );

    if (selectedValue?.followUp) {
      followUpContainer.appendChild(
        this.renderDropdown(selectedValue.followUp)
      );
    }
  };

  result.select.addEventListener('change', () => {
    updateFollowUp();
    this.handleChange();
  });

  return result.container;
}

  /**
   * Renders a dimension field group (single or dual inputs)
   * @param {Object} dimension - Dimension config object
   * @returns {HTMLElement} Dimension field container
   */
  renderDimension(dimension) {
    const container = document.createElement('div');
    container.className = 'product-bespoke-dimension';
    container.dataset.dimensionId = dimension.id;

    const labelRow = document.createElement('div');
    labelRow.className = 'product-bespoke-dimension__label-row';

    const label = document.createElement('span');
    label.className = 'product-bespoke-dimension__label';
    label.textContent = dimension.label;
    labelRow.appendChild(label);

    if (dimension.helpText) {
      labelRow.appendChild(this.renderTooltip(dimension.helpText));
    }

    container.appendChild(labelRow);

    const inputsRow = document.createElement('div');
    inputsRow.className = 'product-bespoke-dimension__inputs';

    inputsRow.appendChild(this.createDimensionField(
      dimension, 'dim1', dimension.label1, dimension.min1, dimension.max1
    ));

    if (dimension.label2) {
      inputsRow.appendChild(this.createDimensionField(
        dimension, 'dim2', dimension.label2, dimension.min2, dimension.max2
      ));
    }

    container.appendChild(inputsRow);

    return container;
  }

  /**
   * Creates a single dimension input field with label and range hint
   * @param {Object} dimension - Parent dimension config
   * @param {string} slot - 'dim1' or 'dim2'
   * @param {string} fieldLabel - Field label text
   * @param {number} min - Minimum value
   * @param {number} max - Maximum value
   * @returns {HTMLElement} Field container
   */
  createDimensionField(dimension, slot, fieldLabel, min, max) {
    const field = document.createElement('div');
    field.className = 'product-bespoke-dimension__field';

    const inputWrap = document.createElement('div');
    inputWrap.className = 'product-bespoke-dimension__input-wrap';

    const input = document.createElement('input');
    input.type = 'number';
    input.className = 'product-bespoke-dimension__input';
    input.dataset.dimensionId = dimension.id;
    input.dataset.slot = slot;
    input.dataset.label = dimension.label;
    input.dataset.fieldLabel = fieldLabel;
    input.dataset.minMm = min;
    input.dataset.maxMm = max;
    input.required = true;
    input.placeholder = fieldLabel;
    input.step = 'any';

    const imperial = isImperial();
    updateInputMinMax(input, min, max, imperial);

    input.addEventListener('input', () => this.handleChange());
    input.addEventListener('blur', () => this.validateDimensionInput(input));

    inputWrap.appendChild(input);

    const unit = document.createElement('span');
    unit.className = 'product-bespoke-dimension__unit';
    unit.textContent = imperial ? '"' : 'mm';
    inputWrap.appendChild(unit);

    const hint = document.createElement('span');
    hint.className = 'product-bespoke-dimension__range-hint';
    hint.dataset.minMm = min;
    hint.dataset.maxMm = max;
    hint.textContent = formatDimensionRange(min, max, imperial);
    inputWrap.appendChild(hint);

    field.appendChild(inputWrap);

    const errorMsg = document.createElement('span');
    errorMsg.className = 'product-bespoke-dimension__error';
    errorMsg.hidden = true;
    field.appendChild(errorMsg);

    return field;
  }

  /**
   * Renders a confirmation checkbox field
   * @param {Object} confirmation - Confirmation config object
   * @returns {HTMLElement} Confirmation field container
   */
  renderConfirmation(confirmation) {
    const container = document.createElement('div');
    container.className = 'product-bespoke-confirmation';
    container.dataset.confirmationId = confirmation.id;

    const row = document.createElement('div');
    row.className = 'product-bespoke-confirmation__row';

    const checkbox = document.createElement('button');
    checkbox.type = 'button';
    checkbox.className = 'product-bespoke-confirmation__input';
    checkbox.setAttribute('role', 'checkbox');
    checkbox.setAttribute('aria-checked', 'false');
    checkbox.setAttribute('aria-label', confirmation.label);
    checkbox.innerHTML = icons.check();
    checkbox.addEventListener('click', (e) => {
      e.preventDefault();
      const isChecked = checkbox.getAttribute('aria-checked') === 'true';
      checkbox.setAttribute('aria-checked', String(!isChecked));
      checkbox.classList.toggle('product-bespoke-confirmation__input--checked', !isChecked);
      this.handleChange();
    });

    const label = document.createElement('span');
    label.className = 'product-bespoke-confirmation__label';

    const labelText = document.createElement('span');
    labelText.textContent = confirmation.label;
    label.appendChild(labelText);

    if (confirmation.helpText) {
      label.appendChild(document.createTextNode(' '));
      label.appendChild(this.renderTooltip(confirmation.helpText));
    }

    row.appendChild(checkbox);
    row.appendChild(label);
    container.appendChild(row);

    return container;
  }

  /**
   * Renders a tooltip trigger button with popover content
   * @param {string} helpText - HTML content for the tooltip
   * @returns {HTMLElement} Tooltip wrapper element
   */
  renderTooltip(helpText) {
    const wrap = document.createElement('span');
    wrap.className = 'product-bespoke-options__tooltip-wrap';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'product-bespoke-options__tooltip-trigger';
    trigger.innerHTML = icons.infoCircle();
    trigger.setAttribute('aria-label', 'More information');

    const tooltip = document.createElement('div');
    tooltip.className = 'product-bespoke-options__tooltip';

    const header = document.createElement('div');
    header.className = 'product-bespoke-options__tooltip-header';

    const closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'product-bespoke-options__tooltip-close';
    closeBtn.innerHTML = icons.close();
    closeBtn.setAttribute('aria-label', this.getTranslation('tooltip_close', 'Close'));
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      tooltip.classList.remove('product-bespoke-options__tooltip--open');
    });

    header.appendChild(closeBtn);

    const content = document.createElement('div');
    content.className = 'product-bespoke-options__tooltip-content';
    content.innerHTML = helpText;

    tooltip.appendChild(header);
    tooltip.appendChild(content);

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = tooltip.classList.contains('product-bespoke-options__tooltip--open');
      this.closeAllTooltips();
      if (!isOpen) tooltip.classList.add('product-bespoke-options__tooltip--open');
    });

    wrap.appendChild(trigger);
    wrap.appendChild(tooltip);

    return wrap;
  }

  /**
   * Closes all open tooltips within this component
   */
  closeAllTooltips() {
    const tooltips = this.querySelectorAll('.product-bespoke-options__tooltip');
    tooltips.forEach(t => { t.classList.remove('product-bespoke-options__tooltip--open'); });
  }

  /**
   * Sets up outside click handler to close tooltips
   */
  setupOutsideClickHandler() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.product-bespoke-options__tooltip-wrap')) {
        this.closeAllTooltips();
      }
    });
  }

  /**
   * Handles any input change — recalculates price, validates, dispatches event
   */
  handleChange() {
    this.priceAdjustment = this.calculatePriceAdjustment();
    this.validate();

    this.dispatchEvent(new CustomEvent('bespoke:change', {
      bubbles: true,
      detail: {
        isValid: this.isValid,
        priceAdjustment: this.priceAdjustment
      }
    }));
  }

  /**
   * Validates a dimension input on blur and shows error state if out of range
   * @param {HTMLInputElement} input - The dimension input element
   */
  validateDimensionInput(input) {
    this.touchedDimensions.add(input);

    const validation = getDimensionValidation(input);
    const data = parseDimensionData(input);

    const field = input.closest('.product-bespoke-dimension__field');
    const wrap = input.closest('.product-bespoke-dimension__input-wrap');
    const errorMsg = field?.querySelector('.product-bespoke-dimension__error');

    if (wrap) {
      wrap.classList.toggle('product-bespoke-dimension__input-wrap--error', validation.isOutOfRange);
    }

    if (errorMsg) {
      errorMsg.hidden = !validation.isOutOfRange;
      if (validation.isOutOfRange) {
        const translations = {
          minError: this.getTranslation('dimensionMinError', 'Min is'),
          maxError: this.getTranslation('dimensionMaxError', 'Max is'),
        };
        errorMsg.textContent = getDimensionErrorMessage(validation, data.minMm, data.maxMm, translations);
      }
    }

    this.handleChange();
  }

  /**
   * Formats a dimension value in the current unit
   * @param {number} mmValue - Value in millimeters
   * @returns {string} Formatted value with unit symbol
   */
  formatDimensionValue(mmValue) {
    return formatDimension(mmValue);
  }

  /**
   * Validates all bespoke fields
   * @returns {boolean} True if all required fields are valid
   */
  validate() {
    let valid = true;

    const selects = this.querySelectorAll('.product-bespoke-dropdown__select');
    selects.forEach(select => {
      const isInvalid = !select.value;
      select.classList.toggle('product-bespoke-dropdown__select--error', this.showErrors && isInvalid);
      if (isInvalid) valid = false;
    });

    const dimInputs = this.querySelectorAll('.product-bespoke-dimension__input');
    dimInputs.forEach(input => {
      const validation = getDimensionValidation(input);
      const data = parseDimensionData(input);
      const isEmpty = !validation.hasValue;
      const isInvalid = isEmpty || validation.isOutOfRange;
      const isTouched = this.touchedDimensions.has(input);
      const showFieldError = (this.showErrors || isTouched) && isInvalid;

      const field = input.closest('.product-bespoke-dimension__field');
      const wrap = input.closest('.product-bespoke-dimension__input-wrap');
      const errorMsg = field?.querySelector('.product-bespoke-dimension__error');

      if (wrap) wrap.classList.toggle('product-bespoke-dimension__input-wrap--error', showFieldError);

      if (errorMsg) {
        const showRangeError = (this.showErrors || isTouched) && validation.isOutOfRange;
        errorMsg.hidden = !showRangeError;
        if (showRangeError) {
          const translations = {
            minError: this.getTranslation('dimensionMinError', 'Min is'),
            maxError: this.getTranslation('dimensionMaxError', 'Max is'),
          };
          errorMsg.textContent = getDimensionErrorMessage(validation, data.minMm, data.maxMm, translations);
        }
      }

      if (isInvalid) valid = false;
    });

    const checkbox = this.querySelector('.product-bespoke-confirmation__input');
    if (checkbox) {
      const isInvalid = checkbox.getAttribute('aria-checked') !== 'true';
      checkbox.classList.toggle('product-bespoke-confirmation__input--error', this.showErrors && isInvalid);
      if (isInvalid) valid = false;
    }

    this.isValid = valid;

    if (this.validationMessage) {
      this.validationMessage.hidden = !this.showErrors || valid;
    }

    return valid;
  }

  /**
   * Shows validation errors (called externally by product-variants.js)
   */
  showValidationErrors() {
    this.showErrors = true;
    this.validate();

    const firstError = this.querySelector(
      '.product-bespoke-dropdown__select--error, ' +
      '.product-bespoke-dimension__input-wrap--error, ' +
      '.product-bespoke-confirmation__input--error'
    );
    if (firstError) {
      firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  /**
   * Calculates total price adjustment from all bespoke selections
   * @returns {number} Total adjustment in cents
   */
  calculatePriceAdjustment() {
    let total = 0;
    const imperial = isImperial();

    const selects = this.querySelectorAll('.product-bespoke-dropdown__select');
    selects.forEach(select => {
      if (select.value) {
        const selectedOpt = select.options[select.selectedIndex];
        total += parseInt(selectedOpt.dataset.priceAdjustment) || 0;
      }
    });

    if (this.config?.dimensions) {
      this.config.dimensions.forEach(dimDef => {
        const dim1Input = this.querySelector(
          `.product-bespoke-dimension__input[data-dimension-id="${dimDef.id}"][data-slot="dim1"]`
        );
        if (dim1Input && dim1Input.value) {
          let valueMm = parseFloat(dim1Input.value);
          if (imperial) {
            valueMm = toMm(valueMm);
          }
          const pricePerMm = dimDef.pricePerMm1 || 0;
          if (valueMm > dimDef.min1 && pricePerMm > 0) {
            total += Math.round((valueMm - dimDef.min1) * pricePerMm);
          }
        }

        const dim2Input = this.querySelector(
          `.product-bespoke-dimension__input[data-dimension-id="${dimDef.id}"][data-slot="dim2"]`
        );
        if (dim2Input && dim2Input.value) {
          let valueMm = parseFloat(dim2Input.value);
          if (imperial) {
            valueMm = toMm(valueMm);
          }
          const pricePerMm = dimDef.pricePerMm2 || 0;
          if (valueMm > dimDef.min2 && pricePerMm > 0) {
            total += Math.round((valueMm - dimDef.min2) * pricePerMm);
          }
        }
      });
    }

    return total;
  }

  /**
   * Returns price adjustment total (public API for product-variants.js)
   * @returns {number} Total adjustment in cents
   */
  getPriceAdjustment() {
    return this.priceAdjustment;
  }

  /**
   * Returns cart line item properties for all bespoke selections
   * @returns {Object} Key-value pairs for cart properties
   */
  getCartProperties() {
    const properties = {};

    const selects = this.querySelectorAll('.product-bespoke-dropdown__select');
    selects.forEach(select => {
      if (select.value) {
        const selectedOpt = select.options[select.selectedIndex];
        const dropdownLabel = select.dataset.label;
        const valueLabel = selectedOpt.dataset.label;
        if (dropdownLabel && valueLabel) {
          properties[dropdownLabel] = valueLabel;
          if (selectedOpt.dataset.swatch) {
            properties[`_${dropdownLabel}_swatch`] = selectedOpt.dataset.swatch;
          }
        }
      }
    });

    const dimInputs = this.querySelectorAll('.product-bespoke-dimension__input');
    const imperial = isImperial();
    let hasDimensions = false;
    dimInputs.forEach(input => {
      if (input.value) {
        const dimLabel = input.dataset.label;
        const fieldLabel = input.dataset.fieldLabel;
        if (dimLabel && fieldLabel) {
          let mmValue = parseFloat(input.value);
          if (imperial) {
            mmValue = toMm(mmValue);
          }
          properties[`${dimLabel} ${fieldLabel} (mm)`] = mmValue.toString();
          hasDimensions = true;
        }
      }
    });

    if (hasDimensions) {
      properties._unitPreference = imperial ? 'inches' : 'mm';
    }

    const checkbox = this.querySelector('.product-bespoke-confirmation__input');
    if (checkbox && checkbox.getAttribute('aria-checked') === 'true') {
      const confirmContainer = checkbox.closest('.product-bespoke-confirmation');
      if (confirmContainer) {
        const label = confirmContainer.querySelector('.product-bespoke-confirmation__label span');
        if (label) {
          properties[label.textContent] = 'Yes';
        }
      }
    }

    if (Object.keys(properties).length > 0) {
      properties._hasOptions = 'true';
    }

    if (this.priceAdjustment && this.priceAdjustment !== 0) {
      properties._priceAdjustment = this.priceAdjustment.toString();
    }

    return properties;
  }

  /**
   * Resets all bespoke fields to their default empty state
   */
  reset() {
    const selects = this.querySelectorAll('.product-bespoke-dropdown__select');
    selects.forEach(select => {
      select.selectedIndex = 0;
      select.classList.remove('product-bespoke-dropdown__select--error');
    });

    const dimInputs = this.querySelectorAll('.product-bespoke-dimension__input');
    dimInputs.forEach(input => {
      input.value = '';
      const field = input.closest('.product-bespoke-dimension__field');
      const wrap = input.closest('.product-bespoke-dimension__input-wrap');
      const errorMsg = field?.querySelector('.product-bespoke-dimension__error');
      if (wrap) wrap.classList.remove('product-bespoke-dimension__input-wrap--error');
      if (errorMsg) errorMsg.hidden = true;
    });

    const checkbox = this.querySelector('.product-bespoke-confirmation__input');
    if (checkbox) {
      checkbox.setAttribute('aria-checked', 'false');
      checkbox.classList.remove(
        'product-bespoke-confirmation__input--checked',
        'product-bespoke-confirmation__input--error'
      );
    }

    this.showErrors = false;
    this.touchedDimensions.clear();
    this.handleChange();
    refreshCustomDropdowns(this, this.config?.dropdown);
  }

  /**
   * Restores bespoke form values from cart line item properties
   * @param {Object} properties - Cart properties object (e.g. {"Handing": "Left Hand", "Overall Size Width (mm)": "750"})
   */
  restoreFromProperties(properties) {
    if (!properties || Object.keys(properties).length === 0) return;

    const selects = this.querySelectorAll('.product-bespoke-dropdown__select');
    selects.forEach(select => {
      const dropdownLabel = select.dataset.label;
      const savedValue = properties[dropdownLabel];
      if (!savedValue) return;

      for (let i = 0; i < select.options.length; i++) {
        if (select.options[i].dataset.label === savedValue) {
          select.selectedIndex = i;
          break;
        }
      }
    });

    const dimInputs = this.querySelectorAll('.product-bespoke-dimension__input');
    dimInputs.forEach(input => {
      const dimLabel = input.dataset.label;
      const fieldLabel = input.dataset.fieldLabel;
      const key = `${dimLabel} ${fieldLabel} (mm)`;
      if (properties[key]) {
        input.value = properties[key];
      }
    });

    const checkbox = this.querySelector('.product-bespoke-confirmation__input');
    if (checkbox) {
      const confirmContainer = checkbox.closest('.product-bespoke-confirmation');
      if (confirmContainer) {
        const label = confirmContainer.querySelector('.product-bespoke-confirmation__label span');
        if (label && properties[label.textContent] === 'Yes') {
          checkbox.setAttribute('aria-checked', 'true');
          checkbox.classList.add('product-bespoke-confirmation__input--checked');
        }
      }
    }

    this.handleChange();
    refreshCustomDropdowns(this, this.config?.dropdown);
  }

  /**
   * Gets a translation string from the component's data attributes
   * @param {string} key - Translation key
   * @param {string} fallback - Fallback text
   * @returns {string} Translated text
   */
  getTranslation(key, fallback) {
    return this.dataset[`t${key.charAt(0).toUpperCase() + key.slice(1)}`] || fallback;
  }

  /**
   * Formats money value from cents to display string
   * @param {number} cents - Price in cents
   * @returns {string} Formatted price
   */
  formatMoney(cents) {
    const pounds = (cents / 100).toFixed(2);
    return `£${pounds}`;
  }
}

customElements.define('product-bespoke-options', ProductBespokeOptions);

})();
